module.exports = __webpack_public_path__ + "static/media/Øre.b53285f4.PNG";